module.exports = __webpack_public_path__ + "img/link-icon.5622979c.svg";